module.exports = __webpack_public_path__ + "resources\\localization\\fr-fr.json";


/*****************
 ** WEBPACK FOOTER
 ** ./src/resources/localization/fr-fr.json
 ** module id = 31
 ** module chunks = 0
 **/